<template>
  <div class="planning-calendar">
    <VDatePicker
      ref="calendar"
      v-model.range="datesInternal"
      borderless
      :first-day-of-week="2"
      color="orange"
      :attributes="attributes"
      class="v-calendar-padding extracadabra-calendar"
      :class="{ 'planning-calendar-sticky': sticky }"
      :locale="DEFAULT_LANGUAGE"
      :rows="numberOfRows"
      :from-date="datesInternal.start"
      @update:pages="onCalendarPageChange"
    />
  </div>
</template>

<script>
  import { DEFAULT_LANGUAGE } from "@core/constants";

  import { CalendarShiftsSummaryListModel } from "@core/models";
  import { EventManager } from "@core/managers/event.manager";
  import { ETAB_EVENTS } from "@etab/config";

  let previouslySelectedMonth = new Date().getMonth() + 1;

  export default {
    props: {
      shifts: {
        type: Object,
        default: () => new CalendarShiftsSummaryListModel(),
      },
      sticky: {
        type: Boolean,
        default: false,
      },
      dateRange: {
        type: Object,
        default: () => {
          return { start: null, end: null };
        },
      },
    },
    emits: ["update:dateRange"],
    computed: {
      attributes() {
        return [
          {
            bar: {
              class: "bg-positive",
            },
            dates: this.shifts.getBookedDates().map((summary) => summary.getDate()),
          },
          {
            bar: {
              class: "bg-negative",
            },
            dates: this.shifts.getCanceledDates().map((summary) => summary.getDate()),
          },
        ];
      },
      datesInternal: {
        get() {
          return this.dateRange;
        },
        set(value) {
          if (value) {
            const { start, end } = value;
            this.$emit("update:dateRange", { start, end });
            this.$refs.calendar.move(start);
            EventManager.emit(ETAB_EVENTS.SHIFT_PLANNING.GET_SHIFTS_FROM_DATES, { start, end });
          }
        },
      },
      numberOfRows() {
        // small screen
        if (this.$q.screen.lt.md || this.$q.screen.height < 900) {
          return 1;
        }
        // large screen
        return 2;
      },
    },
    created() {
      this.DEFAULT_LANGUAGE = DEFAULT_LANGUAGE;
    },
    methods: {
      onCalendarPageChange(pageDate) {
        if (this.shouldUpdateCalendar(pageDate[0].month - 1)) {
          const date = new Date(pageDate[0].year, pageDate[0].month - 1);
          EventManager.emit(ETAB_EVENTS.SHIFT_PLANNING.GET_CALENDAR_FROM_DATE, { date });
        }
      },
      shouldUpdateCalendar(currentPageMonth) {
        const shouldUpdateCalendar = previouslySelectedMonth !== currentPageMonth;
        previouslySelectedMonth = currentPageMonth;
        return shouldUpdateCalendar;
      },
    },
  };
</script>

<style lang="scss">
  .planning-calendar {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;

    .planning-calendar-sticky {
      position: fixed;
    }

    .v-calendar-custom {
      box-shadow: $card-shadow;
    }
  }
</style>
